import React from 'react';
import { ColorProperty } from 'csstype';
import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import clsx from 'clsx';

import { useStyleString } from '../../hooks';

const useStyle = makeStyles<Theme, ColorProps>(createStyles({
  button: {
    backgroundColor: ({ backgroundColor }) => backgroundColor,
    color: ({ fontColor }) => fontColor,
    width: '240px',
    height: '40px',
    border: 'none',
    padding: '10px 10px',
    borderRadius: '3px',
    fontSize: '16px',
    fontWeight: 600,
  },
}), { name: 'ButtonPreview' });

type ColorProps = {
  backgroundColor: ColorProperty;
  fontColor: ColorProperty;
};

type Props = ColorProps & {
  children?: React.ReactNode;
  className?: string;
  stringStyle: string;
};

const ButtonPreview = ({
  backgroundColor,
  fontColor,
  children,
  className,
  stringStyle,
}: Props) => {
  const classes = useStyle({ backgroundColor, fontColor });
  const inlineStyle = useStyleString(stringStyle);

  return (
    <button className={clsx(classes.button, className, inlineStyle)}>
      {children}
    </button>
  );
};

export default ButtonPreview;
